import ComposeViewState from '../store/schema/ComposeViewState';
import InfoBarMessageViewStateCreator from 'owa-info-bar/lib/schema/InfoBarMessageViewStateCreator';
import addInfoBarMessage from 'owa-info-bar/lib/actions/addInfoBarMessage';
import { action } from 'satcheljs/lib/legacy';

const addInfoBarMessageInCompose = action('addInfoBarMessageInCompose')(
    function addInfoBarMessageInCompose(
        viewState: ComposeViewState,
        messageId: string,
        infoBarMessageViewStateCreator?: InfoBarMessageViewStateCreator
    ) {
        addInfoBarMessage(
            viewState,
            messageId,
            viewState.composeId,
            infoBarMessageViewStateCreator
        );
    }
);

export default addInfoBarMessageInCompose;
